import { cx } from '@emotion/css';
import React, { memo, useCallback, useState } from 'react';
import { ix } from '../../../../utils/ix';
import { BaseFilterMenu } from '../BaseFilterMenu';
import { DEFAULT_MAX_NAME_LENGTH } from './ViewsMenu.constants';
import { useStyles } from './ViewsMenu.styles';
import { ChipContent } from './components/ChipContent';
import { MenuContent } from './components/MenuContent';
const COMPONENT_ID = 'views-menu';
export const ViewsMenu = memo(function ({ activeView, className, commonViewsPermissions, hasUnsavedChanges, id, loading, maxNameLength = DEFAULT_MAX_NAME_LENGTH, onClick, onCreate, onDelete, onEdit, onPin, onUnpin, size, views, }) {
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false);
    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);
    const handleChipClick = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);
    const handleViewClick = useCallback((view) => {
        onClick(view);
        setIsOpen(false);
    }, [onClick]);
    const getId = useCallback((...ids) => ix(id, COMPONENT_ID, ...ids), [id]);
    return (React.createElement(BaseFilterMenu, { className: cx(className, classes.root), id: id, open: isOpen, onChipClick: handleChipClick, onClose: handleClose, size: size, chipContent: React.createElement(ChipContent, { activeView: activeView, hasUnsavedChanges: hasUnsavedChanges, id: getId(), isOpen: isOpen }), menuContent: React.createElement(MenuContent, { key: isOpen.toString(), id: getId(), activeView: activeView, commonViewsPermissions: commonViewsPermissions, loading: loading, maxNameLength: maxNameLength, onClick: handleViewClick, onCreate: onCreate, onDelete: onDelete, onEdit: onEdit, onPin: onPin, onUnpin: onUnpin, views: views }) }));
});
//# sourceMappingURL=ViewsMenu.js.map